import React, {useEffect, useRef, useState} from "react";
import {useLocation,useParams,useHistory} from "react-router-dom";
import "../Customer/Customer.scss";
import SimpleLineIcon from "react-simple-line-icons";
import 'swiper/swiper-bundle.min.css'
import Swiper from "swiper";
import {AccessTokenData, ConvertToJalali, FactorData, RateData, RateSend} from "../Customer/CustomerServices";
import ReactGA from "react-ga";
import {useDispatchMall} from "../../hooks/useDispatchMall";
import {useDispatchStore, useDispatchUser, usePrompt, useStore} from "../../hooks";
import {InstallData, SetInstallData} from "../../Components/Nav/NavServices";
import {CheckChrom, isInStandaloneMode, LogRequest} from "../../Services";
import {FCMAllow} from "../../Components/NotificationAllow/FCMAllow";
import Invoice from "../Invoice/Invoice";
import {CheckinMall} from "../StoreDetail/StoreDetailServices";


import Lottie from 'react-lottie';
import  animationData from '../../assets/json/gift.json';
import {FactorSec} from "../Home/Sections/FactorSec";
import {ReferralSec} from "../Home/Sections/ReferralSec";
import {InvoiceCoverSec} from "../Home/Sections/InvoiceCoverSec";
import {CampaignList, MyRecentMerchant, RewardList} from "../Home/Sections";
import {MyRecentMerchantMenu} from "../Home/Sections/MyRecentMerchantMenu";
import {TextSec} from "../Home/Sections/TextSec";
import {MultipleList} from "../Home/Sections/MultipleList";
import {MyInvoiceList} from "../Home/Sections/MyInvoiceList";
import {LazyImage, Slider} from "../../Components";
import {acceptReferralApi, getReferralApi} from "./ReferralServices";
import {getUser} from "../../Services";
import VideoSec from "../Home/Sections/VideoSec";
import AudioSec from "../Home/Sections/AudioSec";
import {ProductRegal} from "../../Components/ProductRegal/ProductRegal";

const merchantIgnoreUid = ["Wkhv8PwghL","N6gbxpMed9"]


let mainFactor = {}



function ReferralText({referralDetail}){
    return(
        <div className="merchant-desc">
            <div style={{padding:"5px 0"}}></div>
            {referralDetail.inviter_user?<p className="coupon_message">
                شما توسط <span className="referrer-name"> {referralDetail.inviter_user.first_name+ " " + referralDetail.inviter_user.last_name } </span>
                به {referralDetail.type===1?"  ":"  "} <span className="referrer-name">{referralDetail.type===1?referralDetail.merchant.name:referralDetail.campaign.title}</span> دعوت شده اید . شما میتوانید با استفاده از این اپلیکیشن از جشنواره ها و تخفیف های ویژه و بهرمند شوید .
            </p>:null}
            <br/>
        </div>
    )
}


function ReferralLand() {


    const { merchantId, referralId} = useParams();

    //states
    const [preload,setPreload] = useState(true);
    const [failed,setFailed] = useState(false);
    const [factor,setFactor] = useState({});
    const [page,set_page] = useState(null);
    const [rate,setRate] = useState(null);
    const [customerRateShow,setCustomerRateShow] = useState(false);
    const [showGiftSection,setShowGiftSection] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [fcmAllow, set_fcmAllow] = useState(false);




    //hooks
    const location = useLocation();
    const { token } = useParams();
    const history= useHistory();
    const setMall = useDispatchMall();
    const setUser = useDispatchUser();
    const prompt = usePrompt();
    const inputRef = useRef(null)
    const fire = useStore();
    const setFire = useDispatchStore();


    // --------------------------------------------------------------------------------- dynamic start


    const [button_list, set_button_list] = useState([]);
    const [button_list2, set_button_list2] = useState([]);
    const [slider, set_slider] = useState([]);
    const [single_bar, set_single_bar] = useState([]);
    const [banner, setBanner] = useState([]);
    const [dual_bar, set_dual_bar] = useState([]);
    const [dual_bar_a, set_dual_bar_a] = useState([]);
    const [triad_big_left, set_triad_big_left] = useState([]);

    const [left, set_left] = useState({});
    const [right_top, set_right_top] = useState({});
    const [right_bottom, set_right_bottom] = useState({});

    const [right, set_right] = useState({});
    const [left_top, set_left_top] = useState({});
    const [left_bottom, set_left_bottom] = useState({});

    const [homi, setHomi] = useState([]);
    const [referralDetail,set_referralDetail] = useState({})



    const sendReferrer = async ()=>{
        if(referralDetail.invited_user){
            await acceptReferralApi(referralDetail.merchant.uid,referralDetail.uid)
            if(referralDetail && referralDetail.referral_page && referralDetail.referral_page.destination){
                history.push(`${referralDetail.referral_page.destination}`)
            }else{
                history.push(`/home`)
            }
            // if(referralDetail.type===1)
            //     history.push(`/store-detail/${referralDetail.merchant.uid}`)
            // else
            //     history.push(`/festival-detail/${referralDetail.campaign.uid}`,{festival:referralDetail.campaign})
        }
    }



    const setHome = (home) => {

        let yy = home.data.sortBy('order');
        console.log("4444444444444",yy)
        setHomi(yy)


        //find data ---
        let button_list_loc = home.data.find(data => data.section_type === "button_list");
        let button_list2_loc = home.data.filter(data => data.section_type === "button_list");
        let slider_loc = home.data.find(data => data.section_type === "slider");
        let single_bar_loc = home.data.filter(data => data.section_type === "single_bar");
        let dual_bar_loc = home.data.find(data => data.section_type === "dual_bar");
        let dual_bar_a_loc = home.data.filter(data => data.section_type === "dual_bar");
        let triad_big_left_loc = home.data.find(data => data.section_type === "triad_big_left");
        let triad_big_right_loc = home.data.find(data => data.section_type === "triad_big_right");
        let banner_loc = home.data.find(data => data.section_type === "single_banner");

        if (dual_bar_a_loc) {
            set_dual_bar_a(dual_bar_a_loc)
        }

        // set States
        if (banner_loc) {
            setBanner(banner_loc.items);
        }

        if (button_list_loc) {
            set_button_list(button_list_loc.items)
        }

        if (button_list2_loc) {
            set_button_list2(button_list2_loc)
        }


        if (slider_loc) {
            set_slider(slider_loc.items)
        }

        if (single_bar_loc) {
            let items = single_bar_loc.map(item=>item.items[0]);
            set_single_bar(items)
        }

        if (dual_bar_loc) {
            set_dual_bar(dual_bar_loc.items)
        }


        if (triad_big_left_loc) {
            set_triad_big_left(triad_big_left_loc.items)
        }




        if (triad_big_left_loc) {
            let left_loc = triad_big_left_loc.items.find(data => data.position === "left");
            let left_top_loc = triad_big_left_loc.items.find(data => data.position === "right_top");
            let left_bottom_loc = triad_big_left_loc.items.find(data => data.position === "right_bottom");
            if (left_loc) {
                set_left(left_loc)
            }
            if (left_top_loc) {
                set_left_top(left_top_loc)
            }
            if (left_bottom_loc) {
                set_left_bottom(left_bottom_loc)
            }
        }


        if (triad_big_right_loc) {
            let right_loc = triad_big_right_loc.items.find(data => data.position === "right");
            let right_top_loc = triad_big_right_loc.items.find(data => data.position === "left_top");
            let right_bottom_loc = triad_big_right_loc.items.find(data => data.position === "left_bottom");
            if (right_loc) {
                set_right(right_loc)
            }
            if (right_top_loc) {
                set_right_top(right_top_loc)
            }
            if (right_bottom_loc) {
                set_right_bottom(right_bottom_loc)
            }
        }

    }



    const LinkDispatcher = (link,obj) => {
        switch (link) {
            case 'mall_campaigns':
                history.push('/festivals')
                break;
            case 'mall_campaign_details':
                history.push(`/festival-detail/${obj.link_to_uid}`,{festival:{uid:obj.link_to_uid}})
                break;
            case 'my_rewards':
                history.push('/reward')
                break;
            case 'mall_merchant_details':
                history.push(`/store-detail/${obj.link_to_uid}`,{store:{uid:obj.link_to_uid}})
                break;
            case 'merchant_online_store':
                if(obj.link_to_uid){
                    history.push('/online-store/'+obj.link_to_uid)
                }
                break;
            case 'checkin':
                history.push('/scan')
                break;
            case 'merchant_product':
                let replace = obj.link_to_uid.replace(/'/g, '"');
                let parsedPay =JSON.parse(replace);
                if(parsedPay.merchant_uid && parsedPay.product_uid){
                    history.push(`/online-store-product/${parsedPay.merchant_uid}/${parsedPay.product_uid}`)
                }
                break;
            case 'merchant_category_without_subcategory':
                history.push('/store')
                break;
            case 'mall_food_court':
                history.push('/store',{catLink:{uid:obj.link_to_uid}})
                break;
            case 'credit_package':
                history.push('/reward')
                break;
            case 'mall_parking':
                history.push('/store')
                break;
            case 'mall_event_details':
                history.push(`/event-detail/${obj.link_to_uid}`,{event:{uid:obj.link_to_uid}})
                break;
            case 'merchant_menu':
                history.push(`/menu/${obj.link_to_uid}`,{event:{uid:obj.link_to_uid}})
                break;
            case 'live':
                livePreview(obj)
                break;
            case 'call_center':
                let local_user = localStorage.getItem("user")
                let user_obj = JSON.parse(local_user)
                let new_topic = obj.link_to_uid.replace("REPLACE",user_obj.uid)
                history.push(`/chat/${new_topic}`)
                break;
            default:
                console.log("default")
        }
    }

    const livePreview = (obj)=>{
        window.open(obj.link_to_uid, "_blank")
    }


    const getReferral = async ()=>{
        setPreload(true)

        try{
            const res= await getReferralApi(referralId,merchantId)
            set_referralDetail(res.data);
            if(res.data.referral_page){
                set_page(res.data.referral_page.sections)
                let home ={data:[]};
                home['data'] = res.data.referral_page.sections
                setHome(home);
            }

            set_merchant(res.data.merchant)

            if(res.data.invited_user){
                localStorage.setItem('token',res.data.invited_user.access_token);
                localStorage.setItem('shop_token',res.data.invited_user.access_token);
                localStorage.removeItem('user');
                localStorage.setItem('mallId',res.data.merchant.mall.uid);
                localStorage.setItem('mallLogo',res.data.merchant.mall.header_image);
                localStorage.setItem('mallWhite',res.data.merchant.mall.logo);
                localStorage.setItem('mallName',res.data.merchant.mall.name);
                localStorage.setItem('mall',JSON.stringify(res.data.merchant.mall));
                setMall(res.data.merchant.mall);

                let user = await getUser()
                localStorage.setItem('user',JSON.stringify(user.data));
            }

            setPreload(false)

        }catch (e) {
            setPreload(false)
            console.log(e)
        }
    }



    // --------------------------------------------------------------------------------- dynamic end


    useEffect(()=>{

        if(referralId && merchantId)
            getReferral(referralId,merchantId)

    },[])






    const swiper = useRef(null)
    const Loop = ()=>{
        setInterval(()=>{
            swiper.current.slideNext();
        },2000)
    }

    useEffect(()=>{
        swiper.current=new Swiper('.swiper-container',{
            loop:true,
            autoplay: {
                delay: 5000,
            },
        })
        //Loop();
    },[])






    const gotoHome = () =>{
        //Log Chart
        LogRequest({type:"CLICK_MORE",meta:factor.uid})
        localStorage.setItem('mallId',factor.merchant.mall.uid);
        localStorage.setItem('mallLogo',factor.merchant.mall.header_image);
        localStorage.setItem('mallWhite',factor.merchant.mall.logo);
        localStorage.setItem('mallName',factor.merchant.mall.name);
        localStorage.setItem('mall',JSON.stringify(factor.merchant.mall));
        setMall(factor.merchant.mall);
        history.push("/home",{customer:true})
    }




    //animation

    const [isStopped,set_isStopped] = useState(true)
    const [isPaused,set_isPaused] = useState(false)

    const buttonStyle = {
        display: 'block',
        margin: '10px auto'
    };

    const defaultOptions = {
        loop: false,
        autoplay: false,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }

    };

    const gotoReferral = () =>{

        console.log(mainFactor)

        //Log Chart
        LogRequest({type:"CLICK_MORE",meta:mainFactor.uid})
        localStorage.setItem('mallId',mainFactor.merchant.mall.uid);
        localStorage.setItem('mallLogo',mainFactor.merchant.mall.header_image);
        localStorage.setItem('mallWhite',mainFactor.merchant.mall.Logo);
        localStorage.setItem('mallName',mainFactor.merchant.mall.name);
        localStorage.setItem('mall',JSON.stringify(mainFactor.merchant.mall));
        setMall(mainFactor.merchant.mall);
        history.push(`/referral/${mainFactor.merchant.uid}`,{item:mainFactor.merchant})
    }

    const [merchant,set_merchant] = useState({})





    return(

        <div className="customer-container">


            <div className="customer-header">
                <span>دعوت از دوستان</span>
            </div>




            {!preload?

                <div className="customer-main">
                    {!page?<div className="customer-body">

                        <div className="landing-container">
                            <div className="a-pluse-subject">
                                {merchant?<img src={merchant.thumbnail} alt=""/>:null}
                                {merchant?<span> {merchant.name}</span>:null}
                            </div>
                            <div className="menu-container landing-back" style={{backgroundImage: `url(${referralDetail.merchant && referralDetail.merchant.cover})`}}>

                                <ReferralText referralDetail={referralDetail}/>


                                {merchant?<div className="float-btn-wri">
                                    <div className="float-btni" onClick={()=>{
                                        sendReferrer()
                                    }}>
                                        <i className="fa fa-angle-left"></i>
                                        {referralDetail.merchant?<span> ورود به  {referralDetail.merchant.name}</span>:null}
                                    </div>
                                </div>:null}


                            </div>
                        </div>

                    </div>:null}

                    <div className="customer-footer">

                    </div>
                </div>
                :<div className="customer-preLoading">
                    {!failed?<div className="customer-preloading-body">
                        <img src="/svg/pre.gif" alt=""/>
                    </div>:<div className="customer-failed-body">
                        <img src="/svg/failed.svg" alt=""/>
                        <span>اطلاعاتی موجود نیست</span>
                    </div>}


                </div>}



            {!preload ? <div className="new-home" style={{marginTop:57}}>
                {page?                <>

                        {homi.map(item=>{
                            switch (item.section_type) {
                                case 'my_recent_merchant':
                                    return (
                                        <MyRecentMerchant item={item}/>
                                    )
                                    break;
                                case 'merchant_menu':
                                    return (
                                        <MyRecentMerchantMenu item={item}/>
                                    )
                                    break;
                                case 'invoice_text':
                                    return (
                                        <ReferralText referralDetail={referralDetail}/>
                                    )
                                    break;
                                case "mall_products":
                                    return(
                                        <ProductRegal item={item}/>
                                    )
                                    break;
                                case 'video_content':
                                    return (
                                        <VideoSec item={item}/>
                                    )
                                    break;
                                case 'audio_content':
                                    return (
                                        <AudioSec item={item}/>
                                    )
                                    break;
                                case 'referral':
                                    return (
                                        <ReferralSec gotoReferral={gotoReferral}/>
                                    )
                                    break;

                                case 'invoice_cover':
                                    return (
                                        <InvoiceCoverSec factor={factor} />
                                    )
                                    break;

                                case 'reward_list':
                                    return (
                                        <RewardList item={item}/>
                                    )
                                    break;
                                case 'campaign_list':
                                    return (
                                        <CampaignList item={item}/>
                                    )
                                    break;
                                case 'blogpost_text':
                                    return (
                                        <TextSec item={item}/>
                                    )
                                    break;
                                case 'multiple_banner':
                                    return (
                                        <MultipleList item={item}/>
                                    )
                                    break;
                                case 'my_invoice_list':

                                    return (
                                        <MyInvoiceList item={item}/>
                                    )
                                    break;
                                case 'slider':
                                    return (
                                        <div>
                                            <Slider uid={item.uid} dispatch={LinkDispatcher} data={item.items}/>
                                        </div>
                                    )
                                    break;
                                case 'dual_bar':
                                    return (
                                        <div className="block-pool" style={{order: 2}}>

                                            <div className="block-item-horizontal">
                                                <div className="wrapper" onClick={() => LinkDispatcher(item.items[0].link_to,item.items[0])}>
                                                    {item.items[0] ?
                                                        <>
                                                            {/*<img src={item.items[0].image} alt=""/>*/}
                                                            <LazyImage type={'side'} src={item.items[0].image}/>
                                                            <span className="block-title">{item.items[0].title}</span>
                                                        </>
                                                        : null}
                                                </div>

                                                <div className="wrapper" onClick={() => LinkDispatcher(item.items[1].link_to,item.items[1])}>
                                                    {item.items[1] ?
                                                        <>
                                                            {/*<img src={item.items[1].image} alt=""/>*/}
                                                            <LazyImage type={'side'} src={item.items[1].image}/>
                                                            <span className="block-title">{item.items[1].title}</span>
                                                        </>
                                                        : null}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                    break;
                                case 'single_bar':
                                    return (
                                        <div key={item.items[0].uid} className="single-bar" onClick={() => LinkDispatcher(item.items[0].link_to,item.items[0])}>
                                            <>
                                                {/*<img  src={item.items[0].image} alt=""/>*/}
                                                <LazyImage type={'banner'} src={item.items[0].image}/>
                                                <span className="block-title">{item.items[0].title}</span>
                                            </>
                                        </div>
                                    )
                                    break;
                                case 'single_banner':
                                    return (
                                        <div key={item.items[0].uid} className="single-bar" onClick={() => LinkDispatcher(item.items[0].link_to,item.items[0])}>
                                            <>
                                                {/*<img  src={item.items[0].image} alt=""/>*/}
                                                <LazyImage type={'banner'} src={item.items[0].image}/>
                                                <span className="block-title">{item.items[0].title}</span>
                                            </>
                                        </div>
                                    )
                                    break;
                                case 'triad_big_right':
                                    return (
                                        <div className="block-container">
                                            {/*left*/}
                                            {/*right*/}
                                            {right.image?<div className="block-pool" style={{order: 1}}>
                                                <div className="block-item-vertical">
                                                    <div className="wrapper" onClick={() => LinkDispatcher(right_top.link_to,right_top)}>
                                                        <img className="max-height" src={right_top.image} alt=""/>
                                                        <span className="block-title">{right_top.title}</span>
                                                    </div>
                                                    <div className="wrapper" onClick={() => LinkDispatcher(right_bottom.link_to,right_bottom)}>
                                                        <img  className="max-height" src={right_bottom.image} alt=""/>
                                                        <span className="block-title">{right_bottom.title}</span>
                                                    </div>
                                                </div>
                                                <div className="block-item-vertical">
                                                    <div className="wrapper" onClick={() => LinkDispatcher(right.link_to,right)}>
                                                        <img src={right.image} alt=""/>
                                                        <span className="block-title">{right.title}</span>
                                                    </div>
                                                </div>
                                            </div>:null}
                                        </div>
                                    )
                                    break;
                                case 'triad_big_left':
                                    return (
                                        <div className="block-container">
                                            {/*left*/}
                                            {left.image?<div className="block-pool" style={{order: 1}}>
                                                <div className="block-item-vertical">
                                                    <div className="wrapper" onClick={() => LinkDispatcher(left.link_to,left)}>
                                                        <img src={left.image} alt="" />
                                                        <span className="block-title">{left.title}</span>
                                                    </div>
                                                </div>
                                                <div className="block-item-vertical">

                                                    <div className="wrapper" onClick={() => LinkDispatcher(left_top.link_to,left_top)}>
                                                        <img  className="max-height" src={left_top.image} alt=""/>
                                                        <span className="block-title">{left_top.title}</span>
                                                    </div>
                                                    <div className="wrapper" onClick={() => LinkDispatcher(left_bottom.link_to,left_bottom)}>
                                                        <img className="max-height"   src={left_bottom.image} alt=""/>
                                                        <span className="block-title">{left_bottom.title}</span>
                                                    </div>
                                                </div>
                                            </div>:null}
                                        </div>
                                    )
                                    break;

                                case 'button_list':
                                    return (
                                        <div className="digi_badg_actions">
                                            {item.items.map(itemz => {
                                                return (
                                                    <div key={itemz.uid} className="digi_badg_actions_item" onClick={()=>{ LinkDispatcher(itemz.link_to,itemz)}}>
                                                        <img src={itemz.image} alt="" style={{width: 48}}/>
                                                        <span>{itemz.title}</span>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )
                                    break;
                            }
                        })}

                    </>
                    :null}
            </div> : <div className="customer-preLoading">
                {!failed ? <div className="customer-preloading-body">
                    <img src="/svg/pre.gif" alt=""/>
                </div> : <div className="customer-failed-body">
                    <img src="/svg/failed.svg" alt=""/>
                    <span>اطلاعاتی موجود نیست</span>
                </div>}
            </div>}


            {merchant?<div className="float-btn-wri">
                <div className="float-btni" onClick={()=>{
                    sendReferrer()
                }}>
                    <i className="fa fa-angle-left"></i>
                    {referralDetail.merchant?<span> ورود به  {referralDetail.merchant.name}</span>:null}
                </div>
            </div>:null}



        </div>
    )
}






export {ReferralLand}


